<template>
  <div class="rank-page" :style="{background: !isHidden ? '#24252A' : '#fff'}">
    <div class="no-rank flex column" v-if="isHidden" v-my-loading="loading">
      <!--當前沒有任務-->
      <van-empty class="custom-image" :description="$t('300108')">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-jilu1"></use>
        </svg>
      </van-empty>
      <!--更多活动敬请期待-->
      <p>{{$t('300116')}}</p>
    </div>
    <div v-if="!isHidden" v-my-loading="loading">
      <div class="rank-banner" :style="{backgroundImage:'url(' + bannerUrl + ')'}">
        <h1>{{ $t('300067') }}</h1>
        <p v-html="$t('300068')"></p>
        <van-button color="#FFC72B" @click="handleShare">{{ $t('300069') }}</van-button>
      </div>
      <div class="rank-container">
        <div id="rank">
          <div class="title">
            <div class="flex-center">
              <svg slot="image" class="icon" aria-hidden="true">
                <use xlink:href="#icon-paihangbang"></use>
              </svg>
              <!--排行榜-->
              <h1 class="bold">{{ $t('300070') }}</h1>
            </div>
            <!--返佣排名大作战，最高1BTC等您领！-->
            <span class="block">{{ $t('300073') }}</span>
          </div>
          <ul class="tabs flex-center">
            <li class="tab-item bold pointer" v-for="item in rankTabList" :key="item.value"
                :class="{active:rankActiveId == item.value}" @click="changeRankTab(item)">{{ $t(item.label) }}
            </li>
          </ul>
          <van-notice-bar scrollable color="#FFC72B" background="#fff"
                          v-show="(rankActiveId == 'day' && dailyMsg )|| (rankActiveId == 'total' && totalMsg)"
                          :text="rankActiveId == 'day' ? dailyMsg : totalMsg"/>
          <div class="rank-table">
            <div class="thead flex-between">
              <!--排名  账号  佣金数量-->
              <span class="th">{{ $t('300084') }}</span>
              <span class="th">{{ $t('300085') }}</span>
              <span class="th">{{ $t('300086') }}(USDT)</span>
            </div>
            <ul class="tbody" v-my-loading="rankLoading">
              <li class="tr flex-between" v-for="item in rankList.slice(0,len)" :key="item.id+'a'"
                  :class="{firstBg: item.id == 1,secondBg:item.id == 2,thirdBg: item.id == 3}">
                <span class="td">
                   <svg v-if="item.id == 1" slot="image" class="icon" aria-hidden="true">
                      <use xlink:href="#icon-diyi"></use>
                   </svg>
                  <svg v-else-if="item.id == 2" slot="image" class="icon" aria-hidden="true">
                      <use xlink:href="#icon-dier"></use>
                   </svg>
                  <svg v-else-if="item.id == 3" slot="image" class="icon" aria-hidden="true">
                      <use xlink:href="#icon-disan"></use>
                   </svg>
                  <em v-else class="normal">{{ item.id }}</em>
                </span>
                <span class="td">{{ checkUserName(item.userName) }}</span>
                <span class="td">{{ item.profit }}</span>
              </li>
              <!--查看更多 收起-->
              <li class="view-more pointer" @click="handleMore" v-show="rankList.length > 10">
                {{ ifSHowMore ? $t('300090') : $t('300089') }}
                <van-icon :name="ifSHowMore ? 'arrow-up' : 'arrow-down'"/>
              </li>
              <li>
                <van-empty class="custom-image" :description="$t('300108')" v-show="rankList.length == 0">
                  <svg slot="image" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-jilu1"></use>
                  </svg>
                </van-empty>
              </li>
            </ul>
          </div>
          <!--注：当日排名计算至当日00:00，次日发放奖金，数据可能存在误差仅供参考。-->
          <span class="block tip-message" v-show="rankActiveId == 'day'">{{ $t('300087') }}</span>
          <!--注：活动结束后3个工作日内发放，数据可能存在误差仅供参考。-->
          <span class="block tip-message" v-show="rankActiveId == 'total'">{{ $t('300088') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as configs from "@/../config/config"
import {dailyApi, totalApi, rankConfig} from "../api/spot";
import {getCookie, removeCookie, removeToken, setCookie, setToken} from "../utils/auth";
import {getUserInfo} from "../api/user";
import {Button, Tag, NoticeBar, Icon, Empty} from 'vant'
import {mapGetters} from "vuex";

export default {
  name: "rank",
  components: {
    vanButton: Button,
    vanTag: Tag,
    vanNoticeBar: NoticeBar,
    vanIcon: Icon,
    vanEmpty: Empty
  },
  data() {
    return {
      isApp: '',
      staticState: configs[configs.Edition].staticState,
      userInfo: {},
      isLogin: false, // 登录状态
      rankActiveId: 'day',
      rankTabList: [
        {label: '300076', value: 'day'},
        {label: '300077', value: 'total'}
      ],
      rankList: [],
      len: 10,
      rankLoading: false,
      ifSHowMore: false,
      bannerUrl: '',
      dailyMsg: '',
      totalMsg: '',
      isHidden: false,
      loading: true,
      type: 'login'
    }
  },
  watch: {
    $route() {
      // Toast('监听路由变化')
      this.resher()
      this.getColor()
    }
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  created() {
    this.resher()
    this.getDailyList()
    this.getRankConfig()
    window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
  },
  methods: {
    getRankConfig() {
      rankConfig().then(res => {
        if (!res.data) {
          this.loading = false
          this.isHidden = true
        }else {
          this.isHidden = false
          this.loading = false
          this.bannerUrl = res.data.h5Banner || ''
          this.dailyMsg = res.data.daily || ''
          this.totalMsg = res.data.total || ''
        }
      })
    },
    getDailyList() {
      this.rankLoading = true
      dailyApi({type: 2}).then(res => {
        this.rankLoading = false
        if (res.data) {
          this.len = res.data.length > 10 ? 10 : res.data.length
          res.data.forEach((v, i) => {
            v.id = i + 1
          })
          this.rankList = res.data || []
        }
      })
    },
    getTotalList() {
      this.rankLoading = true
      totalApi({type: 2}).then(res => {
        this.rankLoading = false
        if (res.data) {
          this.len = res.data.length > 10 ? 10 : res.data.length
          res.data.forEach((v, i) => {
            v.id = i + 1
          })
        }
        this.rankList = res.data || []
      })
    },
    // 用户名隐私展示
    checkUserName(userName) {
      if (userName) {
        if (userName.indexOf('@') > -1) {
          return userName
        } else {
          let areaCode = '+' + userName.split('-')[0]
          let phone = userName.split('-')[1]
          return areaCode + ' ' + phone
        }
      } else {
        return '--'
      }
    },
    changeRankTab(item) {
      this.rankActiveId = item.value
      this.rankList = []
      this.ifSHowMore = false
      if (item.value == 'day') {
        this.getDailyList()
      } else {
        this.getTotalList()
      }
    },
    handleMore() {
      this.ifSHowMore = !this.ifSHowMore
      if (this.ifSHowMore) {
        this.len = this.rankList.length > 20 ? 20 : this.rankList.length
      } else {
        this.len = 10
      }
    },
    resher() {
      this.isApp = this.$route.query.isApp
      var token = this.$route.query.token
      setCookie('language', this.$route.query.language ? this.$route.query.language : 'en')
      this.language = this.$route.query.language ? this.$route.query.language : 'en'
      setCookie('language', this.language)
      if (this.isApp == 1) {
        this.$i18n.locale = this.language;
        if (token) {
          setToken(token)
          this.isLogin = true
          this.getUserInfo()
        } else {
          removeToken()
          this.isLogin = false
        }
      } else {
        this.isLogin = getCookie('token') ? true : false;
        if (this.isLogin) {
          this.getUserInfo()
        } else {
          removeToken()
        }
      }
    },
    // 去邀请
    handleShare() {
      if (!this.isLogin) {
        this.appLogin()
        return false
      } else {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goInvite, {code: 200}, (data) => {
        })
      }
    },
    appLogout() {
      var _this = this
      this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogout, {code: 200}, (data) => {
        _this.isLogin = false
        removeToken()
        removeCookie('userInfo')
      })
    },
    appLogin() {
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogin, {code: 200, type: this.type}, (data) => {
        })
        return false
      }
    },
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.code == 403 || res.code == 413) {
          this.appLogout()
          return false
        }
        if (res.data) {
          this.userInfo = res.data;
          setCookie('userInfo', JSON.stringify(res.data))
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.rank-page {
  .no-rank{
    height: 100vh;
    text-align: center;
    justify-content: center;
    /deep/ .van-empty__image {
      svg {
        width: torem(80);
        height: torem(80);
      }
    }

    /deep/ .van-empty__description {
      font-size: torem(12);
      color: #40475A;
    }
    p{
      font-size: torem(14);
      color: #000922;
    }
  }
  .rank-banner {
    height: torem(200);
    width: 100%;
    padding: torem(57.5) torem(28) 0;
    background-repeat: no-repeat;
    background-size: cover;

    h1 {
      @include sc(torem(24), #fff);
      font-family: pingfangsc-medium;
      line-height: 1.5;
    }

    p {
      font-family: pingfangsc-regular;
      @include sc(torem(12), #fff);
      line-height: 1.5;
    }

    /deep/ .van-button {
      border-radius: torem(2);
      padding: torem(1) torem(12);
      height: auto;
      margin-top: torem(6);
    }

    /deep/ .van-button__text {
      @include sc(torem(14), #000922);
      font-family: pingfangsc-regular;
    }
  }

  .rank-container {
    background-color: #fff;
    padding: torem(28) torem(16);
    border-radius: torem(16) torem(16) 0 0;

    ul.tabs {
      li.tab-item {
        @include sc(torem(14), #7F8490);
        padding: torem(4) torem(12);
        line-height: 1.2;
        margin-bottom: torem(12);
      }

      li.active {
        background-color: #FFC72B;
        color: #000922 !important;
        border-radius: torem(2);
      }
    }

    #rank {
      .title {
        margin-bottom: torem(24);

        svg.icon {
          width: torem(21);
          height: torem(21);
        }

        h1 {
          margin: 0 torem(8);
          font-size: torem(16);
          color: #000922;
        }

        span {
          margin-top: torem(9);
          font-size: torem(12);
          color: #7F8490;
        }
      }

      .tip-message {
        font-size: torem(12);
        color: #7F8490;
        margin: torem(8) 0;
        line-height: 1.5;
      }

      /deep/ .van-notice-bar {
        border: torem(0.55) solid #FFC72B;
        margin: 0 0 torem(8);
        padding: torem(8) torem(12);
        height: torem(30);
        border-radius: torem(4);
      }

      /deep/ .van-notice-bar__content {
        font-size: torem(12);
      }

      .rank-table {
        margin-bottom: 24px;

        .thead {
          .th {
            width: 40%;
            padding: torem(8) 0;
            font-size: torem(13);
            color: #7F8490;

            &:first-child {
              width: 20%;
              padding-left: torem(12);
            }
            &:last-child{
              text-align: right;
            }
          }
        }

        .tbody {
          .tr {
            width: 100%;
            padding: torem(10.5) 0;

            .td {
              width: 40%;
              line-height: 1;
              font-size: torem(13);
              color: #000922;

              svg.icon {
                width: torem(20);
                height: torem(20);
              }

              em.normal {
                margin-left: torem(6);
              }

              &:first-child {
                width: 20%;
                padding-left: torem(12);
              }
              &:last-child{
                text-align: right;
                padding-right: torem(12);
              }
            }

            &:first-child {
              border-radius: torem(2) torem(2) 0 0;
            }
          }

          .firstBg {
            background: linear-gradient(90deg, rgba(255, 199, 43, 0.1) 0%, rgba(255, 199, 43, 0) 100%);
          }

          .secondBg {
            background: linear-gradient(90deg, rgba(223, 223, 223, 0.1) 0%, rgba(225, 171, 121, 0) 100%);
          }

          .thirdBg {
            background: linear-gradient(90deg, rgba(243, 213, 196, 0.1) 0%, rgba(225, 171, 121, 0) 100%);
          }

          .view-more {
            text-align: center;
            margin-top: 24px;
            font-size: torem(12);
            color: #40475A;

            /deep/ .van-icon {
              font-size: torem(12);
              color: #40475A;
              vertical-align: torem(-2);
            }
          }

          /deep/ .van-empty__image {
            svg {
              padding-top: torem(20);
              width: torem(80);
              height: torem(80);
            }
          }

          /deep/ .van-empty__description {
            font-size: torem(12);
            color: #40475A;
          }
        }
      }
    }
  }

}


</style>



// WEBPACK FOOTER //
// src/view/rank.vue